import React, { useEffect, useState } from "react";
import axios from "axios";
import "./styles.css";

//const API = "http://127.0.0.1:8001";

const API = process.env.REACT_APP_API_URL;

function CvDashboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [emailOptions, setEmailOptions] = useState([]);
  const [emailLoading, setEmailLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [viewCandidate, setViewCandidate] = useState(null);

  const [form, setForm] = useState({
    email: "",
    location: "",
    working_hours: "",
    working_days: "",
    current_salary: "",
    expected_salary: "",
    reason_to_leave: "",
    reporting_to: "",
    notice_period: "Immediate",
    family_status: "Single",
    work_mode: "Onsite",
  });

  const TABLE_COLUMNS = [
    { key: "candidate_name", label: "Candidate Name" },
    { key: "email", label: "Email" },
    { key: "date_created", label: "Date Created" },
    { key: "location", label: "Location" },
    { key: "contact_number", label: "Contact Number" },
    { key: "current_salary", label: "Current Salary" },
    { key: "expected_salary", label: "Expected Salary" },
    { key: "position", label: "Position" },
    { key: "overall_fit_rating", label: "Overall Fit Rating" },
  ];

const token = localStorage.getItem("admin_token");

  const fetchData = async () => {
    setTableLoading(true);
    try {
      const res = await axios.get(`${API}/candidates`, {
  headers: {
    Authorization: `Bearer ${token}`
  }
});
      setData(res.data);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const searchEmails = async (value) => {
  setForm({ ...form, email: value });
  setError("");

  if (!value) {
    setEmailOptions([]);
    return;
  }

  setEmailLoading(true);
  try {
    const res = await axios.get(`${API}/emails?q=${value}`);
    setEmailOptions(res.data);
  } catch (err) {
    console.error(err);
  } finally {
    setEmailLoading(false);
  }
};

  const submitForm = async () => {
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/update-candidate`, form);
      setShow(false);
      fetchData();
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError("Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h1>📄 CV Screening Dashboard</h1>

      <div className="top-actions">
        <button className="btn primary" onClick={() => setShow(true)}>
          ➕ Add Details
        </button>
      </div>

      {/* ================= ADD DETAILS MODAL ================= */}
      {show && (
        <div className="modal overlay">
          <div className="modal-content">
            <h2>Add Candidate Details</h2>

            <div className="email-search">
  <input
    placeholder="Search Email"
    value={form.email}
    onChange={(e) => searchEmails(e.target.value)}
    className={error ? "input-error" : ""}
  />

  {emailLoading && <div className="hint">Searching...</div>}

  {emailOptions.length > 0 && (
    <div className="dropdown">
      {emailOptions.map((email, i) => (
        <div
          key={i}
          className="dropdown-item"
          onClick={() => {
            setForm({ ...form, email });
            setEmailOptions([]);
          }}
        >
          {email}
        </div>
      ))}
    </div>
  )}
</div>

{error && <div className="error-text">{error}</div>}

            {error && <div className="error-text">{error}</div>}

            <input placeholder="Location" onChange={(e) => setForm({ ...form, location: e.target.value })} />
            <input placeholder="Working Hours" onChange={(e) => setForm({ ...form, working_hours: e.target.value })} />
            <input placeholder="Working Days" onChange={(e) => setForm({ ...form, working_days: e.target.value })} />
            <input placeholder="Current Salary" onChange={(e) => setForm({ ...form, current_salary: e.target.value })} />
            <input placeholder="Expected Salary" onChange={(e) => setForm({ ...form, expected_salary: e.target.value })} />
            <textarea placeholder="Reason to Leave" onChange={(e) => setForm({ ...form, reason_to_leave: e.target.value })} />
            <input placeholder="Reporting To" onChange={(e) => setForm({ ...form, reporting_to: e.target.value })} />

            <select onChange={(e) => setForm({ ...form, notice_period: e.target.value })}>
              <option>Immediate</option>
              <option>15 days</option>
              <option>1 month</option>
              <option>2 months</option>
            </select>

            <select onChange={(e) => setForm({ ...form, family_status: e.target.value })}>
              <option>Single</option>
              <option>Married</option>
            </select>

            <select onChange={(e) => setForm({ ...form, work_mode: e.target.value })}>
              <option>Onsite</option>
              <option>Offsite</option>
              <option>Hybrid</option>
            </select>

            <div className="actions">
              <button className="btn primary" onClick={submitForm} disabled={loading}>
                {loading ? <span className="spinner"></span> : "Submit"}
              </button>
              <button className="btn ghost" onClick={() => setShow(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* ================= TABLE ================= */}
      <div className="table-wrapper">
        {tableLoading ? (
          <div className="table-loader">
            <span className="spinner dark"></span>
            <p>Loading candidates...</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                {TABLE_COLUMNS.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  {TABLE_COLUMNS.map((col) => (
                    <td key={col.key}>{row[col.key] || "-"}</td>
                  ))}
                  <td>
                    <button className="btn ghost" onClick={() => setViewCandidate(row)}>
                      👁
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* ================= VIEW MODAL ================= */}
      {viewCandidate && (
        <div className="modal overlay">
          <div className="modal-content view-modal">
            <div className="modal-header">
              <h2>👤 Candidate Profile</h2>
              <button className="close-btn" onClick={() => setViewCandidate(null)}>✕</button>
            </div>

            <div className="section">
              <div className="grid">
                <div><label>Email</label><span>{viewCandidate.email}</span></div>
                <div><label>Location</label><span>{viewCandidate.location || "-"}</span></div>
                <div><label>Position</label><span>{viewCandidate.position || "-"}</span></div>
                <div><label>Role Description</label><span>{viewCandidate.role_description || "-"}</span></div>
                <div><label>Total Experience</label><span>{viewCandidate.total_experience || "-"}</span></div>
                <div><label>Tech/Tools</label><span>{viewCandidate.tech_stack || "-"}</span></div>
                <div><label>Reason to Leave</label><span>{viewCandidate.reason_to_leave || "-"}</span></div>
                <div><label>Working Hours</label><span>{viewCandidate.working_hours || "-"}</span></div>
                <div><label>Working Days</label><span>{viewCandidate.working_days || "-"}</span></div>
                <div><label>Work Mode</label><span className="badge">{viewCandidate.work_mode || "-"}</span></div>
                <div><label>Family Status</label><span>{viewCandidate.family_status || "-"}</span></div>
                <div><label>Notice Period</label><span>{viewCandidate.notice_period || "-"}</span></div>
               <div className="text-block">
                <label>Candidate Strength</label>
                <p>{viewCandidate.candidate_strength || "-"}</p>
               </div>
               <div className="text-block">
                <label>Candidate Weakness</label>
                <p>{viewCandidate.candidate_weakness || "-"}</p>
               </div>
                <div>
                  <label>Risk Level</label>
                  <span className="badge danger">{viewCandidate.risk_factor_level || "-"}</span>
                </div>
                    <div>
                  <label>Risk Factor Explanation</label>
                  <p>{viewCandidate.risk_factor_explanation || "-"}</p>
                </div>
                <div>
                  <label>Reward Level</label>
                  <span className="badge success">{viewCandidate.reward_factor_level || "-"}</span>
                </div>
                <div>
                  <label>Reward Factor Explanation</label>
                  <p>{viewCandidate.reward_factor_explanation || "-"}</p>
                </div>
                <div><label>Fit Duration</label><span>{viewCandidate.fit_duration || "-"}</span></div>
                <div>
                  <label>Overall Fit Rating</label>
                  <span className="badge danger">{viewCandidate.overall_fit_rating || "-"}</span>
                </div>
                    <div>
                  <label>Justification</label>
                  <p>{viewCandidate.justification || "-"}</p>
                </div>
                
              </div>
            </div>
            <div className="actions right">
              <button className="btn ghost" onClick={() => setViewCandidate(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CvDashboard;
